<!-- Ad Campaigns -->
<lib-ad-sponsor-banner
  *ngIf="entityId"
  [entityId]="entityId"
  [entityType]="type"
  [hideHeader]="true"
>
</lib-ad-sponsor-banner>
<!-- Team Filter -->
<lib-picker-slider
  *ngIf="topTeams"
  [items]="topTeams"
  [colorScheme]="colorScheme"
  (onSelect)="onItemSelect($event)"
>
</lib-picker-slider>
<div class="spinner-container {{ colorScheme.main }}" *ngIf="isLoading">
  <mat-spinner
    strokeWidth="2"
    color="accent"
    diameter="54"
    class="m-auto"
  ></mat-spinner>
</div>
<ng-container *ngIf="showVideoContent && !isLoading; else noReplaysTemplate">
  <div class="camera-videos-container" *ngIf="!isLoading" #subSection>
    <lib-match-section
      *ngIf="livestreams.length > 0"
      title="Livestreams"
      titleIcon="play_circle"
      moreButtonTitle="Mehr Livestreams"
      moreButtonRouterLink="/livestreams"
      [matches]="livestreams"
      [colorScheme]="colorScheme"
    ></lib-match-section>
    <lib-news-section
      *ngIf="videoNews.length > 0"
      title="Aus dem Studio"
      titleIcon="newspaper"
      moreButtonRouterLink="/news"
      [newsList]="editorialNews"
      [layout]="newsRowLayout"
      [colorScheme]="colorScheme"
    >
    </lib-news-section>
    <lib-match-section
      *ngIf="replays.length > 0"
      title="Nachschauen"
      titleIcon="replay"
      moreButtonTitle="Mehr Replays"
      moreButtonRouterLink="/replays"
      [matches]="replays"
      [colorScheme]="colorScheme"
    ></lib-match-section>
    <lib-abo-banner [name]="bannerName" [user]="user"></lib-abo-banner>
    <lib-ad class="ad"></lib-ad>
    <lib-news-section
      title="Im Fokus"
      titleIcon="whatshot"
      moreButtonText="Mehr News"
      moreButtonRouterLink="/news"
      [newsList]="videoNews"
      [layout]="newsMixedLayout"
      [colorScheme]="colorScheme"
    >
    </lib-news-section>
    <lib-abo-banner
      [type]="AboBannerType.Camera"
      [user]="user"
    ></lib-abo-banner>
  </div>
</ng-container>
<ng-template #noReplaysTemplate>
  <lib-content-card-list
    #subSection
    *ngIf="!isLoading"
    [item]="selectedItem"
    [newsType]="videoNewsType"
    [colorScheme]="colorScheme"
  >
  </lib-content-card-list>
</ng-template>
